import { useNavigate } from "react-router-dom";
import {
  formatOnboardingFieldLabel,
  SELLER_ONBOARDING_PATH,
} from "../features/auth/onboarding";

interface SellerOnboardingAlertProps {
  message: string;
  missingFields?: string[];
  /** Server-supplied {key, label} for each missing field — pass this
   * (from ParsedApiError.missingFieldsDetailed) whenever available; it's
   * always accurate for the live onboarding config, unlike the
   * `missingFields` + formatOnboardingFieldLabel fallback below, which
   * only knows a handful of legacy field names. */
  missingFieldsDetailed?: { key: string; label: string }[];
  returnTo?: string;
  className?: string;
}

const SellerOnboardingAlert: React.FC<SellerOnboardingAlertProps> = ({
  message,
  missingFields = [],
  missingFieldsDetailed,
  returnTo,
  className = "",
}) => {
  const navigate = useNavigate();
  const missingLabels = missingFieldsDetailed?.length
    ? missingFieldsDetailed.map((f) => f.label)
    : missingFields.map(formatOnboardingFieldLabel);

  return (
    <div className={`rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-900 ${className}`.trim()}>
      <p className="text-sm font-medium">{message}</p>
      {missingLabels.length > 0 ? (
        <p className="mt-2 text-sm">
          Missing fields: {missingLabels.join(", ")}
        </p>
      ) : null}
      <button
        type="button"
        onClick={() => navigate(SELLER_ONBOARDING_PATH, { state: returnTo ? { from: returnTo } : undefined })}
        className="mt-3 inline-flex items-center rounded-md bg-amber-600 px-3 py-2 text-sm font-medium text-white hover:bg-amber-700"
      >
        Complete seller onboarding
      </button>
    </div>
  );
};

export default SellerOnboardingAlert;
